<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane v-if="showXTM" label="Transactions" name="Transactions" class="col-11">
        <Transactions-Card/>
      </el-tab-pane>
      <el-tab-pane label="Leads" name="Leads" class="col-11">
        <Leads-Card/>
      </el-tab-pane>
      <el-tab-pane label="Payouts" name="Payouts"  class="col-11">
        <Payouts-Card/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>

  export default {
    name: 'home-tabs',
    props: {},
    mounted () {
      if (!this.$store.getters.incentifyers || this.$store.getters.incentifyers.filter(c => !c.archived).length < 2) {
        // this.$router.push({path: '/dashboard/home/singleview'})
        this.$store.commit('SET_COMPANY_SELECTED', this.$store.getters.incentifyers.filter(c => !c.archived)[0] || 0)
      }
    },
    data () {
      return {
        activeTab: this.$store.getters.leads.lenghth ? 'Leads'
                                                     : this.$store.getters.payouts.lenghth ? 'Payouts'
                                                     : this.$store.getters.paymentCardLogs.length ? 'Transacations'
                                                     : 'Payouts',
        // Those render attributes below are necessary, to render ChartCards only when tab is
        // selected otherwise there's a bug, the ChartCard doesn't render when the tab isn't selected
        renderReceived: false,
        renderClosed: false,
        renderCloseRate: false,
      }
    },
    methods: {
      handleClick () {
      }
    },
    computed: {
      showXTM () {
        return this.$store.getters.isXtmActive
      }
    },
    watch: {
      activeTab: function (tab) {
        switch (tab) {
          case 'EvolutionReceived':
            this.renderReceived = true
            break
          case 'EvolutionClosed':
            this.renderClosed = true
            break
          case 'EvolutionCloseRate':
            this.renderCloseRate = true
            break
        }
      }
    }
  }
</script>
<style>

</style>
